import { IsNotEmpty, IsObject } from 'class-validator';
import { BaseDto } from '../base.dto';

export interface FormDraftDto extends BaseDto {
  entityId: string;
  userAffiliationId: string;
  formData: object;
}

export class UpsertFormDraftDto {
  @IsNotEmpty()
  @IsObject()
  formData: object;
}
